<template>
  <header class="notification--header">
    <span class="logo">
      <img
      class="logo"
      v-bind:src="this.$root.config.logo_image"
      v-bind:alt="this.$root.config.logo_alt"
    />
    </span>
    <h1 class="header--title">
      {{ $root.localize(message) }}
    </h1>
  </header>
</template>

<script>
export default {
    name: "NotificationHeader",

    props: {
        message: {
            type: String,
            required: true,
        },
    },
};
</script>
